/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateApplicationRoute } from 'src/redux/actions/Application';
import { Store } from 'src/types';

const useGoToConfirmationPageIfAlreadyPurchased = () => {
  const application = useSelector((state: Store) => state.application);
  const dispatch = useDispatch();

  useEffect(() => {
    if (application.data.purchased) {
        dispatch(UpdateApplicationRoute('/already-purchased'))
        window.location.replace('/already-purchased');
    }
  }, []);
};

export default useGoToConfirmationPageIfAlreadyPurchased;
